import { HlsConfig } from 'hls.js'
import { merge } from 'lodash'
import ReactVideoPlayer, { ReactPlayerProps } from 'react-player'

import packageJson from '../../../../package.json'

const hlsJsVersion = packageJson.devDependencies['hls.js']

// https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning
const hlsOptions: Partial<HlsConfig> = {
  liveSyncDurationCount: 2,
  liveMaxLatencyDurationCount: 12,
  debug: false
}

const defaultConfig: ReactPlayerProps = {
  config: {
    file: { forceHLS: true, forceSafariHLS: true, hlsVersion: hlsJsVersion, hlsOptions }
  }
}

const ReactPlayer = (props: ReactPlayerProps) => {
  const extendedProps: ReactPlayerProps = merge(defaultConfig, props)
  return <ReactVideoPlayer {...extendedProps} />
}

export default ReactPlayer
